import { render, staticRenderFns } from "./frozenAmount.vue?vue&type=template&id=0edb27a6&scoped=true"
import script from "./frozenAmount.vue?vue&type=script&lang=js"
export * from "./frozenAmount.vue?vue&type=script&lang=js"
import style0 from "./frozenAmount.vue?vue&type=style&index=0&id=0edb27a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb27a6",
  null
  
)

export default component.exports